import {sameVoiceForm} from './assistantFormFill';

// Transcript completion can arrive out of order. Keep the order in which the
// customer spoke, independently of cancelled assistant audio responses.
export function createVoiceFormTurns({getForm,fill,isAlive,onPreview,onPending,onStatus}) {
  const turns=new Map();
  let queue=Promise.resolve(), latestId=null, pending=0, disposed=false;
  let formKey=null;
  function syncForm() {
    const form=getForm(), key=form ? `${form.kind}:${form.id}` : null;
    if(key!==formKey){formKey=key;onPreview('');onStatus('');onPending(0);}
  }
  const alive=()=>!disposed && isAlive();
  const change=count=>{pending+=count;if(alive())onPending(pending);};
  function begin(id) {
    if (!id || turns.has(id)) return;
    syncForm();
    latestId=id;
    onPreview('');onStatus('');
    const form=getForm();
    if (!form) return;
    let resolve;
    const ready=new Promise(done=>{resolve=done;});
    const turn={form,resolve,ready,done:false,partial:'',timer:null};
    turns.set(id,turn);
    turn.result=queue.then(async()=>{
      const text=await ready;
      if(!alive())return 'Voice entry ended. Check the current form.';
      const report=result=>{if(alive() && id===latestId && sameVoiceForm(form,getForm()))onStatus(result || '');return result;};
      if(text===null)return report('I could not hear that complete detail. Please repeat it or type it in the form.');
      change(1);
      try {
        const result=await fill(text,form);
        return report(result);
      } catch {return report('I could not fill in that detail. Please repeat it or type it in the form.');}
      finally {change(-1);}
    });
    queue=turn.result.catch(()=>null);
    // Retain recent results for tool-call deduplication, without unbounded history.
    if(turns.size>200){const first=turns.keys().next().value;if(turns.get(first).done)turns.delete(first);}
  }
  function finish(id,text) {
    const turn=turns.get(id);
    if(!turn || turn.done)return;
    clearTimeout(turn.timer);turn.done=true;
    if(alive() && id===latestId && sameVoiceForm(turn.form,getForm()))onPreview(text || '');
    turn.resolve(text);
  }
  return {
    begin, syncForm,
    stop(id) {const turn=turns.get(id);if(turn && !turn.done && !turn.timer)turn.timer=setTimeout(()=>finish(id,null),12000);},
    delta(id,text) {const turn=turns.get(id);if(!turn || turn.done || !alive())return;turn.partial=(turn.partial+text).slice(0,4000);if(id===latestId && sameVoiceForm(turn.form,getForm()))onPreview(turn.partial);},
    complete(id,text) {finish(id,typeof text==='string' && text.trim() ? text.trim().slice(0,4000):null);},
    fail(id) {finish(id,null);},
    result(id) {return turns.get(id)?.result;},
    form(id) {return turns.get(id)?.form;},
    dispose() {disposed=true;for(const [id] of turns)finish(id,null);},
    get pending() {return pending;}
  };
}
